import { widgetWrapperStyles } from "@tCentro/theme/mixins";
import styled from "styled-components";

const WidgetWrapper = styled.div`
    ${widgetWrapperStyles()}
`;

export default WidgetWrapper;
